module.exports = __webpack_public_path__ + "img/inspirer-of-ideas-3.9383db96.svg";